import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/Tick-GIF.gif'


const _withScopeId = (n: any) => (_pushScopeId("data-v-802cb1b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-capture-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "9 Questions Review", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Time"),
  /*#__PURE__*/_createTextVNode(": 15 minutes")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "What to do:")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Next you will complete the 9 Questions Review, with 3 sections: Personal Indicators, Team Indicators and Organisational Indicators ", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "teams-list-input",
  class: "data-capture-label"
}, [
  /*#__PURE__*/_createTextVNode("But first, please list out the team(s) you are a member of at work. Type each team name one by one and press "),
  /*#__PURE__*/_createElementVNode("em", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" after each entry:")
], -1))
const _hoisted_8 = ["onKeydown"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "new-line input-guidance" }, "Press enter after each name", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Click on which team you consider to be your primary work team (this is the team you will complete the Team Indicators on): ", -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "error-message",
  "data-test": "tagged-teams-error"
}
const _hoisted_14 = {
  key: 1,
  "data-test": "tagged-teams-success"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "success",
    class: "success-img"
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Scroll down to begin the review", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

import { computed, onBeforeUnmount, onMounted, ref, watch, watchEffect } from "vue";
import axios, { AxiosError } from "axios";
import DataTag from "../data-tag.vue";
import SessionInstanceState from "../sessions/session-instance-state";
import { UserTeamsTagDataApiModel } from "../../api-models";
import { csContext } from "../../services/cs-context";
import { useAxios } from "../../composables/api";

const NO_PRIMARY_TEAM_ERROR_MESSAGE = "Please select a primary team";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-post-strength-mapping-capture',
  emits: ["on-submit-data"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const teamName = ref("");

const isSubmitting = ref(false);
const hasSubmitted = ref(false);
const submitErrorMessage = ref<string | null>(null);

const taggedTeams = ref<string[]>([]);
const selectedPrimaryTeamIndex = ref<number | null>(null);

const isSubmitDisabled = computed(() => {
  return selectedPrimaryTeamIndex.value === null || isSubmitting.value;
});

function onDataTagClick(index: number) {
  selectedPrimaryTeamIndex.value = selectedPrimaryTeamIndex.value === index ? null : index;
}

function onButtonRemoveClick(index: number) {
  if (selectedPrimaryTeamIndex.value === index) {
    selectedPrimaryTeamIndex.value = null;
  }
  taggedTeams.value = taggedTeams.value.filter((_, i) => i !== index);
}

function containsOnlyNumbersAndLetters(input: string): boolean {
  const regex = /^[a-zA-Z0-9\s']+$/;
  return regex.test(input);
}

async function onSubmitTaggedTeams() {
  const primaryTeam =
    selectedPrimaryTeamIndex.value !== null
      ? taggedTeams.value[selectedPrimaryTeamIndex.value]
      : null;

  const defaultErrorMessage =
    "There was an error submitting this information, please refresh the page and try again.";

  if (!primaryTeam) {
    submitErrorMessage.value = NO_PRIMARY_TEAM_ERROR_MESSAGE;
    return;
  }

  try {
    await axios.post<UserTeamsTagDataApiModel>("/api/usertagdata/teams", {
      userId: csContext.user.id,
      taggedTeams: taggedTeams.value,
      primaryTaggedTeam: primaryTeam,
    } as UserTeamsTagDataApiModel);
  } catch (err) {
    const error = err as AxiosError;
    const statusCode = error.response?.status;
    isSubmitting.value = false;
    submitErrorMessage.value = statusCode?.toString().startsWith("4")
      ? error.response?.data
      : defaultErrorMessage;
    hasSubmitted.value = false;
    return;
  }

  hasSubmitted.value = true;
  emit("on-submit-data", "postStrengthMapping");
}

function clearErrorMessage() {
  submitErrorMessage.value = null;
}

function addTeamNameToTagList(name: string) {
  if (name.length && !containsOnlyNumbersAndLetters(name.slice(0, -1))) {
    submitErrorMessage.value = "Team name shouldn't contain special characters";
    return;
  }
  const teamAlreadyAddedToList = taggedTeams.value.some(
    (team) => team.toLowerCase() === name.slice(0).toLowerCase(),
  );
  if (!teamAlreadyAddedToList) {
    taggedTeams.value = [...taggedTeams.value, name.slice(0)];
  }
  teamName.value = "";
}

function handleKeyDown(event: KeyboardEvent) {
  if (event.key === "Enter") {
    addTeamNameToTagList(teamName.value);
  }
}

watch(selectedPrimaryTeamIndex, (newValue) => {
  if (newValue !== null && submitErrorMessage.value === NO_PRIMARY_TEAM_ERROR_MESSAGE) {
    submitErrorMessage.value = null;
  }
});

onBeforeUnmount(() => {
  SessionInstanceState.set("teamName", teamName.value);
  SessionInstanceState.set("taggedTeams", taggedTeams.value);
  SessionInstanceState.set("selectedPrimaryTeamIndex", selectedPrimaryTeamIndex.value);
});

onMounted(() => {
  teamName.value = SessionInstanceState.get("teamName") ?? "";
  taggedTeams.value = SessionInstanceState.get("taggedTeams") ?? [];
  selectedPrimaryTeamIndex.value = SessionInstanceState.get("selectedPrimaryTeamIndex") ?? null;
});

function isNotEmptyString(str: string | null | undefined): boolean {
  return str !== null && str !== undefined && str.trim() !== "";
}

const { data } = useAxios<UserTeamsTagDataApiModel>("/api/usertagdata/getteamdata");

watchEffect(() => {
  if (!hasSubmitted.value && isNotEmptyString(data.value?.primaryTaggedTeam)) {
    hasSubmitted.value = true;
    emit("on-submit-data", "postStrengthMapping");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    (!hasSubmitted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(onSubmitTaggedTeams, ["prevent"]),
            class: "data-capture-form"
          }, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "data-capture data-capture-input",
              id: "teams-list-input",
              placeholder: "Team name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((teamName).value = $event)),
              "data-test": "tagged-teams-input",
              onFocus: clearErrorMessage,
              onInput: clearErrorMessage,
              onKeydown: _withKeys(_withModifiers(handleKeyDown, ["prevent"]), ["enter"])
            }, null, 40, _hoisted_8), [
              [
                _vModelText,
                teamName.value,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_9,
            _hoisted_10,
            _createVNode(_TransitionGroup, {
              class: "team-tags-container",
              name: "tags",
              tag: "div"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taggedTeams.value, (team, index) => {
                  return (_openBlock(), _createBlock(DataTag, {
                    key: team,
                    isSelected: index === selectedPrimaryTeamIndex.value,
                    onOnTagClick: ($event: any) => (onDataTagClick(index)),
                    "data-test": "tagged-team"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(team), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn", [
                index === selectedPrimaryTeamIndex.value
                  ? 'btn-close-tag-sm-white'
                  : 'btn-close-tag-sm-black',
              ]]),
                        onClick: _withModifiers(($event: any) => (onButtonRemoveClick(index)), ["stop"]),
                        "data-test": "remove-tag-button"
                      }, null, 10, _hoisted_11)
                    ]),
                    _: 2
                  }, 1032, ["isSelected", "onOnTagClick"]))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              onClick: onSubmitTaggedTeams,
              class: "btn btn-primary btn-lg",
              disabled: isSubmitDisabled.value,
              "data-test": "submit-tagged-teams-button"
            }, " Submit ", 8, _hoisted_12)
          ], 32),
          (submitErrorMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(submitErrorMessage.value), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
  ]))
}
}

})